import { ReactNode } from 'react';
import headingStyle from './SectionHeading.module.scss';

interface IProps {
    eyebrow?: string;
    title: string;
    description?: string;
    align?: 'start' | 'center';
    /** Optional trailing control, e.g. a "view all" link. */
    action?: ReactNode;
}

const SectionHeading = (props: IProps) => {
    const { eyebrow, title, description, align = 'start', action } = props;

    return (
        <div className={`${headingStyle.heading} ${align === 'center' ? headingStyle.center : ''}`}>
            <div className={headingStyle.text}>
                {eyebrow && <span className={headingStyle.eyebrow}>{eyebrow}</span>}
                <h2 className={headingStyle.title}>{title}</h2>
                {description && <p className={headingStyle.description}>{description}</p>}
            </div>
            {action && <div className={headingStyle.action}>{action}</div>}
        </div>
    );
};

export default SectionHeading;
